<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')  
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛名称" )
                    el-input.inputWidth(v-model='dataForm.matchName' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方" )
                    el-select.inputWidth(v-model="dataForm.userGroupId",placeholder="请选择" filterable clearable )
                        el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛类型" )
                    el-select.inputWidth(v-model='dataForm.matchType' clearable )
                        el-option(label="分级公开赛" value="1")
                        el-option(label="俱乐部公开赛" value="2")
                        el-option(label="青少年比赛" value="-1")
              el-col(:md='6' :sm="12")
                el-form-item(label="签位"  )
                    el-input.inputWidth(v-model='dataForm.applySize' clearable placeholder="请输入签位数" )
                      template(slot="suffix") 签位
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛项目")
                    el-select.inputWidth(v-model='dataForm.projectType' @change="changeItem" clearable )
                        el-option(label="单打" value=1)
                        el-option(label="双打" value=2)
              el-col(:md='6' :sm="12")
                el-form-item(label="状态" )
                    el-select.matchStatus.inputWidth(v-model='dataForm.matchStatus' clearable  )
                        el-option(label="未审核" value="10")
                        el-option(label="已发布" value="20")
                        el-option(label="报名中" value="90")
                        el-option(label="报名结束" value="60")
                        el-option(label="已报满" value="70")
                        el-option(label="已开赛" value="80")
                        el-option(label="已取消" value="30")
                        el-option(label="已结束" value="40")
                        el-option(label="已拒绝" value="50")
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛时间")
                    el-date-picker.inputWidth( style='width:210px;'  v-model='dataForm.matchStartTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")

        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='10' :sm="5")
                el-button(@click='addOrUpdateHandle()' v-if="isAuth('ct:level:save')"  type='primary') 新建比赛
                el-button(@click='queryList()',type='primary',icon='el-icon-search') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type="selection" width="50" align='center')
            el-table-column(prop='matchId',header-align='center',align='center',label='比赛ID' width="160")
            el-table-column(prop='matchName',header-align='center',align='center',label='比赛名称' width="120")
            el-table-column(prop='userGroupName',header-align='center',align='center',label='主办方')
            el-table-column(prop='matchType',header-align='center',align='center',label='比赛类型' width="120" )
                template(slot-scope='scope')
                    font(v-if='scope.row.matchType === "1"') 分级公开赛
                    font(v-if='scope.row.matchType === "2"') 俱乐部公开赛
                    font(v-if='scope.row.matchType === "-1"') 青少年比赛
            el-table-column(prop='applySize',header-align='center',align='center',label='签位' width="60")
                template(slot-scope="scope")
                    span() {{scope.row.applySize}}
            el-table-column(prop='projectType',header-align='center',align='center',label='比赛项目' width="120" )
                template(slot-scope='scope')
                    font(v-if='scope.row.projectType === 1') 单打
                    font(v-if='scope.row.projectType === 2') 双打
            el-table-column(prop='matchStartTime',header-align='center',align='center',label='比赛时间' width='160')
            el-table-column(prop='maxVenue',header-align='center',align='center',label='最大场次' width='160')
            el-table-column(prop='establishVenue',header-align='center',align='center',label='成赛场次' width='160')
            el-table-column(prop='refundTime',header-align='center',align='center',label='距开赛自动退费' width='160')
            el-table-column(prop='matchStatus',header-align='center',align='center',label='状态' width="100")
                template(slot-scope="scope")
                    font(v-if='scope.row.matchStatus === 10' )
                      span.danger()
                      span() &nbsp; 未审核
                    font(v-if='scope.row.matchStatus === 20')
                      span.success()
                      span() &nbsp; 已发布
                    font(v-if='scope.row.matchStatus === 90')
                      span.warning()
                      span() &nbsp; 报名中
                    font(v-if='scope.row.matchStatus === 60')
                      span.warning()
                      span() &nbsp; 报名结束
                    font(v-if='scope.row.matchStatus === 70')
                      span.warning()
                      span() &nbsp; 已报满
                    font(v-if='scope.row.matchStatus === 80')
                      span.warning()
                      span() &nbsp; 已开赛
                    font(v-if='scope.row.matchStatus === 30')
                      span.warning()
                      span() &nbsp; 已取消
                    font(v-if='scope.row.matchStatus === 40')
                      span.warning()
                      span() &nbsp; 已结束
                    font(v-if='scope.row.matchStatus === 50')
                      span.warning()
                      span() &nbsp; 已拒绝
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id)" v-if="isAuth('ct:level:info')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,1)" v-if="isAuth('ct:level:update') && [10,50].includes(scope.row.matchStatus)"  type="text" ) 修改比赛
                                el-menu-item(index="1-3" @click='releaseClick(1,scope.row)' v-if="isAuth('ct:level:apply') && scope.row.matchStatus === 10" type='primary') 审核发布
                                el-menu-item(index="1-4" @click='releaseClick(2,scope.row)' v-if="isAuth('ct:level:apply') && (scope.row.matchStatus !== 10 && scope.row.matchStatus !== 50)" type='primary') 比赛关联设置
                                el-menu-item(index="1-7" @click='releaseClick(6,scope.row)' v-if="isAuth('ct:level:out') && [20,40,70,80,90].includes(scope.row.matchStatus)" type='primary') 取消比赛
                                el-menu-item(index="1-8" @click='releaseClick(7,scope.row)' v-if="isAuth('ct:level:over') && [20,40,70,80,90].includes(scope.row.matchStatus)" type='primary') 结束比赛
                                //- el-menu-item(index="1-8" @click='releaseClick(7,scope.row)' v-if="isAuth('ct:level:over')" type='primary') 结束比赛
                                el-menu-item(index="1-9" @click='releaseClick(5,scope.row)' v-if="isAuth('ct:level:copy')" type='primary') 复制并新建

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //查看和审核
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
        //参数人员管理-单打
        ElCompetitionInfo(v-if='elCompetitionInfoVisible',ref="elCompetitionInfo",@refreshDataList='getDataList',@closeHandel="closeElCompetitionInfo")
</template>

<script>
import table from './table.js'
import AddOrUpdate from './add-or-update'
import QueryView from './query-view'
import UpdateCompetition from './update-competition'
import ElCompetitionInfo from './el-competition-info'
export default {
  name: 'ct-competition-level',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      loading: null,
      gradeInfoVisible: false,
      gradeInfoOldVisible: false,
      gradeInfoDoubleVisible: false,
      gradeInfoDoubleOldVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elCompetitionInfoVisible: false,
      siteDeployVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      matchType: null,
      dataListLoading: false,
      // restaurants: [],
      matchId: '',
      dataForm: {
        matchName: null,
        userGroupId: null,
        level: null,
        ctType: null,
        applySize: null,
        projectType: null,
        matchStatus: null,
        matchType: null,
        matchStartTime: []
      },
      levelOptions: [],
      sysOrgList: [],
      levelDisabled: true,
      placeholderLevel: '必须先选择比赛项目',
      levelOptionsOne: [
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' }
      ],
      levelOptionsTwo: [
        { value: '5.0', label: '5.0' },
        { value: '6.0', label: '6.0' },
        { value: '7.0', label: '7.0' },
        { value: '8.0', label: '8.0' },
        { value: '9.0', label: '9.0' },
        { value: '10.0', label: '10.0' }
      ],
      adjustGameSysVisible: false // 调整赛制模态框
    }
  },
  components: {
    AddOrUpdate,
    QueryView,
    UpdateCompetition,
    ElCompetitionInfo
  },
  mounted () {
    this.matchId = this.$route.query.matchId
    this.getDataList()
    //this.restaurants = this.loadAll();
    this.initCity()
    console.log(
      new Date('2019-11-11'.replace(/-/, '/')).getTime() > new Date().getTime()
    )
    console.log(new Date().getTime())
  },
  methods: {
    //推荐或取消推荐
    recommend (id, type) {
      let tips = type == 0 ? '确定取消推荐？' : '确定推荐？'
      let param = {
        id: id,
        recommend: type == 0 ? 0 : 1
      }
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/ctCompetition/updateRecommend'),
          method: 'post',
          data: param
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message.info('已取消！')
      })
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    //参赛人员管理
    enrollClick (row) {
      this.elCompetitionInfoVisible = true
          this.$nextTick(() => {
            this.$refs.elCompetitionInfo.init(row.id,row)
          })
    },
    closeElCompetitionInfo (e) {
      console.log(e)
      this.elCompetitionInfoVisible = false
    },
    //1:审核发布 2:设置参数人数
    releaseClick (type, rows) {
      if (
        type == 1 ||
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 6 ||
        type == 7 ||
        type === 8 // 调整赛制功能
      ) {
        //若比赛处在未审核、已拒绝状态（即未发布），此处提示为比赛尚未发布，不能通过此操作取消比赛。
        //已拒绝的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 5 && type != 1 && type != 3 && type != 5) {
          this.$message.error('比赛尚未发布!')
          return
        }

        //已发布的赛事不能审核发布
        if (rows.matchStatus === 2 && type == 1) {
          this.$message.error('比赛已发布!')
          return
        }
        //已取消的比赛可以复制并新建
        if (rows.matchStatus === 3 && type != 5) {
          this.$message.error('比赛已取消!')
          return
        }
        //已结束的比赛可以录入成绩
        if (rows.matchStatus === 4 && type != 2 && type != 4) {
          this.$message.error('比赛已结束!')
          return
        }
      }
      //审核发布
      if (type == 1) {
        this.queryHandle(rows.id, 'release')
        return
      }
      //设置关联比赛
      if (type == 2) {
        // alert(rows.newCompetition)
        this.enrollClick(rows)
      }
      //安排裁判
      if (type == 3) {
        this.updateRefereeVisible = true
        this.$nextTick(() => {
          this.$refs.updateReferee.init(rows)
        })
      }
      //复制新建
      if (type == 5) {
        this.openFullScreen()
        console.log(rows.id)
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/selfSelection/copyAndAdd/` + rows.id),
          method: 'get'
        }).then((data) => {
          console.log(data)
          // if (data && data.code === 0) {
          //   this.getDataList();
          //   this.$message.success("操作成功!");
          // } else {
          //   this.$message.error("添加失败!");
          // }
          this.loading.close()
          this.addOrUpdateHandle(data.data.id, 2)
        })
      }
      //取消比赛
      if (type == 6) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/list`),
          method: 'post',
          params: this.$http.adornParams({
          page: 1,
          rows: 10,
          matchType: rows.matchType,
          selfCtId: rows.id
        })
        }).then((data) => {
          console.log(data)
          const ctList = data.page.rows
          const hasAllCtCancleOrDelete = !ctList.filter(c => ![3, 4].includes(c.matchStatus)).length > 0
          console.log(hasAllCtCancleOrDelete)
          if (hasAllCtCancleOrDelete) {
            let info = '是否取消比赛？'
            this.$confirm(info, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  this.$http({
                    url: this.$http.adornUrl(
                      `/ctCompetition/selfSelection/updateStatus`
                    ),
                    method: 'post',
                    data: {
                      matchStatus: 30,
                      id: rows.id
                    }
                  }).then((data) => {
                    console.log('data:', data)
                    if (data && data.code == 0) {
                      this.$message.success('比赛已取消')
                    }
                  })
                })
                .catch(() => {
                  this.$message.info('已取消')
                })
          } else {
            this.$message.error('请先取消或结束已关联的比赛！')
          }
        })
      }
      if (type == 7) {
        console.log('结束比赛操作')
        //结束比赛
        let date1 = new Date()
        let date2 = new Date(rows.matchStartTime)
        if (date2.getTime() > date1.getTime()) {
          this.$message.error('比赛尚未开始!')
          return
        }
        //若比赛处在已开赛状态，且未完成成绩录入（即成绩录入表中存在空值），则提示尚未录入成绩，不能通过此操作结束比赛。
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/list`),
          method: 'post',
          params: this.$http.adornParams({
          page: 1,
          rows: 10,
          matchType: rows.matchType,
          selfCtId: rows.id
        })
        }).then((data) => {
          console.log(data)
          const ctList = data.page.rows
          const hasAllCtCancleOrDelete = !ctList.filter(c => ![3, 4].includes(c.matchStatus)).length > 0
          console.log(hasAllCtCancleOrDelete)
          if (hasAllCtCancleOrDelete) {
            this.$confirm('是否结束比赛？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(async () => {
                this.$http({
                  url: this.$http.adornUrl(`/ctCompetition/selfSelection/updateStatus`),
                  method: 'post',
                  data: {
                    matchStatus: 40,
                    id: rows.id
                  }
                }).then((data) => {
                  if (data && data.code == 0) {
                    this.getDataList()
                    this.$message.success('比赛已结束')
                  }else {
                        this.$message.error(data.msg)
                  }
                })
              })
              .catch(() => {
                this.$message.info('操作取消')
              })
          } else {
            this.$message.error('请先取消或结束已关联的比赛！')
          }
        })
      }
      // 调整赛制
      if (type === 8) {
        this.adjustGameSysVisible = true
        this.$nextTick(() => {
          this.$refs.adjustGame.init(rows)
        })
      }
      // 场地管理
      if (type === 9) {
        this.siteDeployVisible = true
        this.$nextTick(() => { 
          this.$refs.siteDeploy.init(rows)
        })
      }
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //查看和审核发布
    queryHandle (id, type) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type)
      })
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true
      let startTime = null
      let endTime = null
      if (this.dataForm.matchStartTime !== null) {
        if (this.dataForm.matchStartTime.length > 0) {
          startTime = this.dataForm.matchStartTime[0]
          endTime = this.dataForm.matchStartTime[1]
        }
      }

      this.$http({
        url: this.$http.adornUrl('/ctCompetition/selfSelection/queryPageList'),
        method: 'post',
        data: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          matchType: this.dataForm.matchType,
          matchName: this.dataForm.matchName,
          userGroupId: this.dataForm.userGroupId || null,
          ctType: this.dataForm.ctType || null,
          applySize: this.dataForm.applySize || null,
          matchStatus: this.dataForm.matchStatus || null,
          projectType: this.dataForm.projectType || null,
          level: this.dataForm.level || null,
          startTime: startTime,
          endTime: endTime,
          matchId: this.matchId
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.page.rows
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    //比赛项目改变事件
    changeItem (value) {
      this.dataForm.level = ''
      if (value.length > 0) {
        this.levelDisabled = false
        this.placeholderLevel = '请选择'
        if (value == '1') {
          this.levelOptions = this.levelOptionsOne
        }
        if (value == '2') {
          this.levelOptions = this.levelOptionsTwo
        }
      } else {
        this.levelDisabled = true
        this.placeholderLevel = '必须先选择比赛项目'
        this.levelOptions = []
      }
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    //勾选列表事件
    selectionChangeHandle (val) {
      let choseVal = []
      // val.
      val.forEach(item => {
        let arr = {
          ctId: item.id,
          clubName: item.matchName
        }
        choseVal.push(arr)
      })
      this.selChangeData = choseVal
      // console.log(this.selChangeData)
      // for (let i = 0; i < choseVal.length; i++) {
      //   if (choseVal[i].matchStatus === 1) {
      //     choseVal[i].matchStatusT = '未审核'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() >
      //     new Date().getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '已发布'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() <=
      //     new Date().getTime() &&
      //     new Date().getTime() <=
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     choseVal[i].joinCount < choseVal[i].applySize
      //   ) {
      //     choseVal[i].matchStatusT = '报名中'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() <=
      //     new Date().getTime() &&
      //     new Date().getTime() <=
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     choseVal[i].joinCount >= choseVal[i].applySize
      //   ) {
      //     choseVal[i].matchStatusT = '已报满'
      //   } else if (
      //     choseVal[i].matchStatusT === 2 &&
      //     new Date().getTime() >
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     new Date().getTime() < new Date(choseVal[i].matchStartTime).getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '报名结束'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date().getTime() > new Date(choseVal[i].matchStartTime).getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '已开赛'
      //   } else if (choseVal[i].matchStatus === 3) {
      //     choseVal[i].matchStatusT = '已取消'
      //   } else if (choseVal[i].matchStatus === 4) {
      //     choseVal[i].matchStatusT = '已结束'
      //   } else if (choseVal[i].matchStatus === 5) {
      //     choseVal[i].matchStatusT = '已拒绝'
      //   }
      //   if (choseVal[i].ctType === 1) {
      //     choseVal[i].ctTypeT = '常规赛'
      //   } else if (choseVal[i].ctType === 2) {
      //     choseVal[i].ctTypeT = '月度赛'
      //   } else if (choseVal[i].ctType === 3) {
      //     choseVal[i].ctTypeT = '季度赛'
      //   } else if (choseVal[i].ctType === 4) {
      //     choseVal[i].ctTypeT = '年度总决赛'
      //   }
      //   choseVal[i].Signature =
      //     choseVal[i].joinCount + '/' + choseVal[i].applySize
      // }
      // this.selChangeData = choseVal
      // console.log(val)
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
</style>
